var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('mouse-pointer'),_c('landing-section'),_c('about-section'),_c('services-section'),_c('approach-section'),_c('clients-section'),_c('contact-section'),_c('newsletter-section'),_c('footer-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }